const headRowsAreas = {
  actions: 'Acciones',
  area: 'Departamento'
}

export default headRowsAreas;
